import React, { Component } from 'react';
import { connect } from 'react-redux';
import { 
  currentNodeState, 
  repositoryState, 
  mappedRepositoryState,
  combineStates, 
  activeTabState, 
  activeTabDispatcher, 
  orderCodeState, 
  combineDispatchers, 
  orderCodeDispatcher,
  popupDispatcher,
  configuratorDispatcher,
  messageDispatcher,
  complexSelectorState,
  complexSelectorDispatcher,
  siteSettingsState,
  showFooterDispatcher,
  nodeState,
  showConfigureState,
  filterSelectorState,
  mobilePageViewDispatcher,
  mobilePageViewState,
  currentPageDispatcher,
  currentPageState,
} from '../../../store';
import { AccessoryConfiguratorPage, ConfiguratorPage, ConfigureByCode, ProductView, ResetButton } from '.';
import { BusyContainer, Tab , CustomMessage } from '../../../components';
import { selectorHelper } from '../../../util';
import { translate } from '../../../services';
import { PropTypes } from 'prop-types';
import { BreadcrumbHeader } from '../navigation';
import { Button, Drawer } from '@mui/material';
import { SideMenuBar } from './SideMenuBar';
import classNames from 'classnames';
import { productWarningIcon } from '../../../../style/images';

export class ProductsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle:false,
      blur:false,
      filterSelectors:null,
      showResetHeader:false,
      currentSelector:"",
    }
    this.blur = false;
    this.configureByCode = this.configureByCode.bind( this );
    this.clearConfiguration = this.clearConfiguration.bind( this );
    this.pageCounter = 0;
  }

  shouldComponentUpdate( nextProps, nextState ) {
    const { activeTab, currentNode, currentSelector, items, complexSelectors } = this.props;

    return activeTab.selector !== nextProps.activeTab.selector ||
           currentNode !== nextProps.currentNode ||
           currentSelector !== nextProps.currentSelector ||
           items !== nextProps.items ||
           complexSelectors !== nextProps.complexSelectors||
           nextState.toggle !== this.state.toggle ||
           nextState.showResetHeader !== this.state.showResetHeader ||
           nextState.blur !== this.state.blur
  }

  componentWillUnmount() {
    // reset the tab to products (preserves actions like they used to be in Phase2)
    //this.props.setTab( 'Products', 'selector' );
  }

  clearConfiguration( productName ) {
    setTimeout( () => this.props.removeConfiguration( { name: productName } ), 0 );
  }

  configureByCode( value ) {
    const { currentNode } = this.props;
    if ( !value ) {
      return;
    }
    const trimmedValue = value.trim();
    this.props.find( trimmedValue, currentNode.customProperties.modelToLoad ).then( product => {
      // no matching code was found
      if ( product === null ) {
        return this.props.addMessage( { 
          messageText: translate( 'No matching product found for "{code}"', { code: trimmedValue } ), 
          messageType: 'warning',
          timeout: 30000 
        } );
      }
      // a code was found, but the product is not available in the database
      if ( product.id === 0 ) {
        return this.props.addMessage( { 
          messageText: translate( 'The product with "{code}" is not available in your country', product ), 
          messageType: 'warning',
          timeout: 30000 
        } );
      }
      return this.props.retrieve( trimmedValue, currentNode.customProperties.modelToLoad ).then( defaultConfiguration => {
        const targetProduct = { 
          ...product, 
          materialName: currentNode.customProperties.modelToLoad, 
          configuration: { 
            sourceLocation: defaultConfiguration.configuration,
            plant: defaultConfiguration.plant,
            usage: defaultConfiguration.usage,
            materialKey: product.name,
            assignments: defaultConfiguration.existingAssignments.select() 
          } };
        this.props.setPopup( {
          title: translate( 'Configure {code}', { code: targetProduct.code || targetProduct.name } ),
          onClose: () => this.clearConfiguration( targetProduct.name ),
          component: <ConfiguratorPage 
            modelToLoad={ currentNode.customProperties.modelToLoad } 
            properties={ { ...currentNode.customProperties, settings: this.props.codeSettings.firstOrDefault( cs => cs.modelName === currentNode.customProperties.modelToLoad ) } }
            product={ targetProduct } isPopup 
          />,
          showHeader: true,
          keepOpen: true,
        } );
      } );
    } );
  }

  updateComplexSelector = ( targetSelectorName, currentSelector ) => {
    this.props.setComplexSelector( { parentSelector: currentSelector.name, targetSelector: targetSelectorName } );
  }

  getCurrentSelector( targetSelector ) {
    const { activeTab, items } = this.props;

    switch( activeTab.selector ) {
      case 'Products':
        return targetSelector.selector;
      case 'Fixed Parts':
        const fixedPartsName = selectorHelper.getFixedPartsName( targetSelector?.selector?.name );
        return items.firstOrDefault( selector => selector.name === fixedPartsName );
      case 'Accessories':
        const accessoriesName = selectorHelper.getAccessoriesName( targetSelector?.selector?.name );
        return items.firstOrDefault( selector => selector.name === accessoriesName );
      case 'Loose Accessories':
        const looseaccessoriesName = selectorHelper.getAccessoriesName( targetSelector?.selector?.name );
        return items.firstOrDefault( selector => selector.name === looseaccessoriesName );
      default:
        return null;
    }
  }

  getResetHeader( currentNode, targetSelector ) {
    const elements = [], currentSelector = this.getCurrentSelector( targetSelector );
    if ( currentNode.customProperties && currentNode.customProperties.orderCodeAvailable ) {
      elements.push(
        { 
          customHeader: <ConfigureByCode configure={ this.configureByCode } currentSelector={ currentSelector } />,
          isDisabled: false
        }
      );
    }
    elements.push( {
      title:"Reset Buttons",
      customHeader: <ResetButton currentSelector={ currentSelector } />,
      isDisabled: false
    } );
    return elements;
  }

  validateNodeCID = () => {
    let nodeCID = this.props.currentNode.nodeId;
    let nodeCIDRegex = new RegExp(this.props.siteSettings.properties.nodeCIDRegex, "g");
    if(nodeCID && nodeCIDRegex.test(nodeCID)) {
      return false;
    } else return true;
  }
  onBack = () => this.pageCounter = this.pageCounter - 2;

  openToggle = ()=>{
    this.setState({toggle:true})
    console.log(this.state.toggle)
  }
  toggleDrawer = ()=>{
    this.setState({toggle:!this.state.toggle})
  }
  
  setBlur = (blur)=>{
    this.setState({blur:blur})
    this.blur = blur
  }
  setShowResetHeader = ()=>{
    if(!this.state.showResetHeader){
      this.setState({showResetHeader:true})
    }
  }

  hideResetHeader = () =>{
    if(this.state.showResetHeader){
      this.setState({showResetHeader:false})
    }
  }
  setNewSelector = (name)=>{
    this.setState({showResetHeader:false, currentSelector:name})
  }
  render() {
    if(this.props.currentPage.currentPage==="configuratorPage" || this.props.currentPage.currentPage==="productPage"){
      this.props.setTab(this.props.activeTab.selector,'selector');
    }else{
      this.props.setTab( 'Products', 'selector' );
    }
    if(this.props.currentPage.currentPage!=="productPage"){
      this.props.setPage("productPage");
    }
    const { currentNode, items, complexSelectors, siteSettings } = this.props;
    const name = currentNode.selectorName;
    const { customProperties = {} } = currentNode;
    if (!name) {      // When we are calling goToProduct from the action panel, the selectorName might be empty here
      // which leads to an error trying to get fixedPartsName
      // the easiest to do, is to let it rerender, thus returning null here, and waiting for the next
      // state change
      return null;
    }
    if(name!==this.state.currentSelector){
      this.setNewSelector(name)
    }
    this.props.hideFooter();

    console.log("rerendered")

    const customMessage = customProperties.customMessage && translate( currentNode.customProperties.customMessage );
    const customMessageColor=currentNode?.customProperties?.customMessageColor;
    const selectorName = selectorHelper.getSelectorName( currentNode.selectorName );
    const accessoriesName = selectorHelper.getAccessoriesName( currentNode.selectorName );
    const actions = ['filter-active'];
    const targetSelector = complexSelectors[name] || { selector: items.firstOrDefault( selector => selector.name === selectorName ) };
    const AccessoriesComponent = AccessoryConfiguratorPage( accessoriesName );
    const fixedPartsName = selectorHelper.getFixedPartsName( targetSelector?.selector?.name );
    const isVT = currentNode.customProperties.isVT;

    const {showOverview, showTenderSpecifications, tenderSpecificationURL} = siteSettings.properties;
    // let headerTab = (this.state.showResetHeader && this.props.activeTab?.selector !== 'Loose Accessories' )&&this.getResetHeader( currentNode, targetSelector );
    let headerTab = (this.state.showResetHeader)&&this.getResetHeader( currentNode, targetSelector );
    let tabs = [
      [
        {
          title: 'Products',
          component: 
            <ProductView 
              onConfigureRequest={ this.configureByCode } 
              parentSelector={ items.firstOrDefault( selector => selector.name === selectorName ) } 
              onSelectorChanged={ this.updateComplexSelector } 
              currentSelector={ targetSelector }
              resetHeader={headerTab}
              showResetHeader = {this.state.showResetHeader}
              setShowResetHeader = {this.setShowResetHeader}
            />,
          properties: this.props,
          isDisabled: items.none( sel => sel.name === selectorName )
        },
        {
          title: 'Fixed Parts',
          component: <ProductView currentSelector={ { selector: items.firstOrDefault( selector => selector.name === fixedPartsName ) } } />,
          properties: this.props,
          isDisabled: items.none( sel => sel.name === fixedPartsName )
        },
        {
          title: 'Loose Accessories',
          component: <AccessoriesComponent hideResetHeader={this.hideResetHeader} resetHeader={headerTab} setShowResetHeader = {this.setShowResetHeader} showResetHeader = {this.state.showResetHeader} currentSelector={ items.firstOrDefault( selector => selector.name === accessoriesName ) } />,
          properties: this.props,
          isDisabled: items.none( sel => sel.name === accessoriesName )
        },
        {
          title: 'Overview',
          href: customProperties.overviewURL,
          properties: this.props,
          isDisabled: !showOverview || !customProperties.overviewURL || this.validateNodeCID(),
        },
        {
          title: 'Tender Specifications',
          href: tenderSpecificationURL + currentNode.nodeId +'/custom',
          properties: this.props,
          isDisabled: !showTenderSpecifications || this.validateNodeCID(),
        },
      ]
    ];

    tabs[0] = tabs[0].concat(headerTab)
    // let className = classNames("product-page", {"blur":this.blur})
    let className = classNames("product-page")
    let productClassName = classNames('product-content')
    return<>
    {/* {this.props.showConfigure.show ? this.props.showConfigure.component:  */}
    <BusyContainer isRequired actions={ actions }>
      <div className={className} style={{width:"100%", filter:"blur(0.5)"}}>
        <SideMenuBar setBlur={this.setBlur} currentNode={this.props.currentNode} node={this.props.node}></SideMenuBar>
        <div className={productClassName}>
          <div className='product-breadcrumb-header' id="product-breadcrumb-header" style={{height:"5%"}}>
            <BreadcrumbHeader 
                  setBack={ this.pageCounter > 1 }
                  onBack={ this.onBack }
                  isIntegrated={ siteSettings.isIntegrated } 
                  pathname={ document.location.hash }
                />
          </div>
          <CustomMessage icon={productWarningIcon} message={ customMessage } color={customMessageColor} node={isVT}/>
          <Tab tabs={ tabs } title="selector"/>
        </div>
      </div>
      </BusyContainer>
      {/* } */}
      </>
  }
}

ProductsComponent.propTypes = {
  activeTab: PropTypes.shape( {
    selector: PropTypes.string.isRequired
  } ),
  addMessage: PropTypes.func.isRequired,
  complexSelectors: PropTypes.shape( {} ),
  currentNode: PropTypes.shape( {
    customProperties: PropTypes.shape( { 
      modelToLoad: PropTypes.string
    } ),
    selectorName: PropTypes.string
  } ), 
  currentSelector: PropTypes.shape( {
    name: PropTypes.string.isRequired
  } ),
  find: PropTypes.func.isRequired,
  items: PropTypes.arrayOf( PropTypes.shape( { name: PropTypes.string } ) ),
  removeConfiguration: PropTypes.func.isRequired,
  retrieve: PropTypes.func.isRequired,
  setComplexSelector: PropTypes.func.isRequired,
  setTab: PropTypes.func.isRequired,
  setPopup: PropTypes.func.isRequired
};

export const Products = connect( 
  combineStates( currentNodeState, nodeState,showConfigureState, activeTabState, siteSettingsState,mobilePageViewState, complexSelectorState, repositoryState( 'selector' ), mappedRepositoryState( 'codeSettings', 'codeSettings' ), orderCodeState, currentPageState ), 
  combineDispatchers( orderCodeDispatcher, complexSelectorDispatcher, popupDispatcher, configuratorDispatcher, messageDispatcher, activeTabDispatcher, showFooterDispatcher, mobilePageViewDispatcher, currentPageDispatcher )
)( ProductsComponent );